<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div>
    <app-pageheader [Parent]="this">
      <a class="button is-primary" [routerLink]="['/enforcement/infringement-types', Model.Id, 'edit']">
        <span class="icon"><i class="fas fa-edit"></i></span>
        <span>Edit Infringement Type</span>
      </a>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Infringement Type</p>
          <div class="panel-block is-block details">
            <a class="panel-block">
              <span class="label">Name</span>
              <span class="value">{{Model.Name}}</span>
            </a>
            <a class="panel-block">
              <span class="label">Description</span>
              <span class="value">{{Model.Description || 'N/A'}}</span>
            </a>
            <a class="panel-block">
              <span class="label">Base Fine</span>
              <span class="value">{{Model.BaseFine | currency:'USD'}}</span>
            </a>
            <a class="panel-block">
              <span class="label">Appeal Eligible</span>
              <span class="value">{{Model.AppealEligible ? 'Yes' : 'No'}}</span>
            </a>
            <a class="panel-block">
              <span class="label">Active</span>
              <span class="value">{{Model.IsActive ? 'Yes' : 'No'}}</span>
            </a>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Pricing Schedule</p>
          <div class="panel-block">
            @if (Model.Escalations?.length) {
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Days After Issuance</th>
                    <th>Additional Fee</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  @for (escalation of Model.Escalations; track escalation) {
                    <tr>
                      <td>{{escalation.Sequence}}</td>
                      <td>{{escalation.DaysAfterIssuance}}</td>
                      <td>{{escalation.AdditionalFee | currency:'USD'}}</td>
                      <td>{{escalation.Description || '-'}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p>No escalation steps configured.</p>
            }
          </div>
        </article>
      </div>
    </div>
  </div>
}


